export const PLANTS=[
    {
        id: 0,
        name: 'Care1',
        image: '/care/img1.jpg',
        heading: 'Feel the Soil to Know How Often to Water Your Plants<',
        description: 'For potted plants at home, you may be unsure of how often to water them. For most plants, the golden rule is to see if the first inch or so of soil is dry. If dry, this is an indication that the plant needs water. If there are leaves that have shriveled or are dry/discolored, the plant might need a little extra water than a regular routine.'
    },
    {
        id: 1,
        name: 'Care1',
        image: '/care/img2.jpg',
        heading: 'It’s Better to Underwater Your Plants Than Overwater Them',
        description: 'A plant can recover faster from being deprived of water than one given excess water. To rescue an overwatered plant, you may need to repot the plant and remove any unhealthy roots and overwatered soil before moving the plant into a new pot.'
    },
    {
        id: 2,
        name: 'Care1',
        image: '/care/img2.jpg',
        heading: 'Skip Fertilization for Houseplants if You’re Unsure',
        description: 'Houseplants don’t require fertilization unless they are struggling to grow. If you’re unsure of how much or what type of fertilization to use when planting, it’s better to skip that step altogether. Too much fertilization may actually end up killing your plant rather than helping it.'
    },
    {
        id: 3,
        name: 'Care1',
        image: '/care/img4.jpg',
        heading: 'Houseplants Love Stability',
        description: 'We recommend scoping out where you’ll put your plant in your house before picking one out. Plants thrive once they are used to their surroundings and finding a spot with the right amount of light is important. Temperature is also important. Fluctuating temperatures will shock your plant and therefore lead to the plant not being able to develop and maybe even die. Most plants prefer temperatures of 65º–75ºF.'
    },
    {
        id: 4,
        name: 'Care1',
        image: '/care/img8.jpg',
        heading: 'Smaller Plants Are the Fastest Growing Plants',
        description: '>When buying your chosen plant, it’s always better to purchase a smaller plant over a larger one. This is because a smaller plant will be able to get more established in its home and have a larger ratio of roots to top growth. A larger plant will not continue to grow until its roots catch up with the top growth.'
    },
    {
        id: 5,
        name: 'Care1',
        image: '/care/img6.jpg',
        heading: 'Water Deeply, Rather Than Lightly and Frequently',
        description: 'When you water lightly and frequently, only the top roots are able to drink the water, and your plant may not receive the fuel it needs to survive. Watering deeply, which entails watering your plants heavily with water, allows for all the roots to grab a drink. To avoid overwatering, slowly water your plant and watch for when the water is not draining through the soil anymore. Once you notice this, stop there.'
    },
    {
        id: 6,
        name: 'Care1',
        image: '/care/img7.jpg',
        heading: 'Prune Your Plants',
        description: 'Getting rid of old-growth on your plants will help your plants grow again. This is kind of like how trimming the dead ends of your hair will help your hair grow again. After winter is when you’ll see some of the tips or leaves of your plant dying, so a simple plant haircut will do!'
    },
    {
        id: 7,
        name: 'Care1',
        image: '/care/img8.jpg',
        heading: 'Most Plants Flourish in High Humidity',
        description: 'With most homes having dry air, especially in the winter, you may want to adjust the air. This could be as simple as purchasing a humidifier for the rooms of your home that contain your adored plants.'
    },
    {
        id: 8,
        name: 'Care1',
        image: '/care/img9.jpg',
        heading: 'Make Sure Pots Have Drainage Holes',
        description: 'Having a way for pots to drain is vital for your plant and the soil. Proper drainage allows the roots to receive air, rather than sitting in water and suffocating the roots.'
    },
    {
        id: 9,
        name: 'Care1',
        image: '/care/img10.jpg',
        heading: 'Dust Your Plants!',
        description: 'Plants that collect too much dust on their leaves can’t get the sunlight they may need to survive, especially green plants and plants with big leaves. A few times per year, use a wet cloth and lightly wipe down the leaves of your plants on both sides. '
    }
]